import { Link } from 'react-router-dom';
import { FeedbackButton } from './feedback-button';

export function Footer() {
  return (
    <footer className="mt-16 border-t border-border py-6 text-center text-xs text-muted-foreground">
      <nav className="flex flex-wrap items-center justify-center gap-3">
        <Link to="/methodology" className="hover:text-foreground">Methodology</Link>
        <span aria-hidden>·</span>
        <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
        <span aria-hidden>·</span>
        <Link to="/terms" className="hover:text-foreground">Terms</Link>
        <span aria-hidden>·</span>
        <FeedbackButton variant="link" label="Have feedback?" />
        <span aria-hidden>·</span>
        <span>© 2026 Fishymeter</span>
      </nav>
      <p className="mt-3">
        Built by{' '}
        <a
          href="https://www.linkedin.com/in/purnaresa/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-foreground"
        >
          Purnaresa
        </a>
        , with a high degree of skepticism.
      </p>
    </footer>
  );
}
